/**
 * IATA Airport Code to City/Country Mapping
 * Used for TransportCard rendering
 */

export interface AirportInfo {
  code: string;
  city: string;
  country: string;
  fullName?: string;
}

export const IATA_AIRPORTS: Record<string, AirportInfo> = {
  // China
  PVG: { code: 'PVG', city: '上海', country: '中国', fullName: '上海浦东国际机场' },
  SHA: { code: 'SHA', city: '上海', country: '中国', fullName: '上海虹桥国际机场' },
  CAN: { code: 'CAN', city: '广州', country: '中国', fullName: '广州白云国际机场' },
  CTS: { code: 'CTS', city: '长春', country: '中国', fullName: '长春龙嘉国际机场' },
  CTU: { code: 'CTU', city: '成都', country: '中国', fullName: '成都天府国际机场' },
  DLC: { code: 'DLC', city: '大连', country: '中国', fullName: '大连周水子国际机场' },
  FUO: { code: 'FUO', city: '福州', country: '中国', fullName: '福州长乐国际机场' },
  CIH: { code: 'CIH', city: '长沙', country: '中国', fullName: '长沙黄花国际机场' },
  NKG: { code: 'NKG', city: '南京', country: '中国', fullName: '南京禄口国际机场' },
  PEK: { code: 'PEK', city: '北京', country: '中国', fullName: '北京首都国际机场' },
  PKX: { code: 'PKX', city: '北京', country: '中国', fullName: '北京大兴国际机场' },
  XIY: { code: 'XIY', city: '西安', country: '中国', fullName: '西安咸阳国际机场' },
  SZX: { code: 'SZX', city: '深圳', country: '中国', fullName: '深圳宝安国际机场' },
  WUH: { code: 'WUH', city: '武汉', country: '中国', fullName: '武汉天河国际机场' },
  CKG: { code: 'CKG', city: '重庆', country: '中国', fullName: '重庆江北国际机场' },
  KMG: { code: 'KMG', city: '昆明', country: '中国', fullName: '昆明长水国际机场' },
  HGH: { code: 'HGH', city: '杭州', country: '中国', fullName: '杭州萧山国际机场' },
  NGB: { code: 'NGB', city: '宁波', country: '中国', fullName: '宁波栎社国际机场' },
  XIE: { code: 'XIE', city: '厦门', country: '中国', fullName: '厦门高崎国际机场' },
  TAO: { code: 'TAO', city: '青岛', country: '中国', fullName: '青岛流亭国际机场' },
  TYN: { code: 'TYN', city: '太原', country: '中国', fullName: '太原武宿国际机场' },
  
  // Hong Kong, Macau, Taiwan
  HKG: { code: 'HKG', city: '香港', country: '香港', fullName: '香港国际机场' },
  MFM: { code: 'MFM', city: '澳门', country: '中国澳门', fullName: '澳门国际机场' },
  TPE: { code: 'TPE', city: '台北', country: '台湾', fullName: '台北桃园国际机场' },
  
  // Southeast Asia
  BKK: { code: 'BKK', city: '曼谷', country: '泰国', fullName: '曼谷素万那普机场' },
  SIN: { code: 'SIN', city: '新加坡', country: '新加坡', fullName: '新加坡樟宜机场' },
  KUL: { code: 'KUL', city: '吉隆坡', country: '马来西亚', fullName: '吉隆坡国际机场' },
  CGK: { code: 'CGK', city: '雅加达', country: '印尼', fullName: '雅加达苏加诺-哈达机场' },
  MNL: { code: 'MNL', city: '马尼拉', country: '菲律宾', fullName: '马尼拉尼诺·阿基诺机场' },
  HAN: { code: 'HAN', city: '河内', country: '越南', fullName: '河内内排国际机场' },
  SGN: { code: 'SGN', city: '胡志明市', country: '越南', fullName: '胡志明市新山一机场' },
  
  // South Asia
  DEL: { code: 'DEL', city: '新德里', country: '印度', fullName: '英迪拉·甘地国际机场' },
  BLR: { code: 'BLR', city: '班加罗尔', country: '印度', fullName: '班加罗尔国际机场' },
  BOM: { code: 'BOM', city: '孟买', country: '印度', fullName: '孟买贾特拉帕蒂·希瓦吉机场' },
  CCU: { code: 'CCU', city: '加尔各答', country: '印度', fullName: '加尔各答内塔吉·苏巴斯国际机场' },
  MAA: { code: 'MAA', city: '金奈', country: '印度', fullName: '金奈国际机场' },
  COK: { code: 'COK', city: '科钦', country: '印度', fullName: '科钦国际机场' },
  DAC: { code: 'DAC', city: '达卡', country: '孟加拉国', fullName: '达卡哈兹·拉特国际机场' },
  KTM: { code: 'KTM', city: '加德满都', country: '尼泊尔', fullName: '加德满都特里布万国际机场' },
  
  // Middle East
  DXB: { code: 'DXB', city: '迪拜', country: '阿联酋', fullName: '迪拜国际机场' },
  AUH: { code: 'AUH', city: '阿布扎比', country: '阿联酋', fullName: '阿布扎比国际机场' },
  DOH: { code: 'DOH', city: '多哈', country: '卡塔尔', fullName: '多哈哈马德国际机场' },
  BIA: { code: 'BIA', city: '巴格达', country: '伊拉克', fullName: '巴格达国际机场' },
  JED: { code: 'JED', city: '吉达', country: '沙特阿拉伯', fullName: '吉达阿卜杜勒-阿齐兹国王国际机场' },
  RUH: { code: 'RUH', city: '利雅得', country: '沙特阿拉伯', fullName: '利雅得国王法赫德国际机场' },
  
  // Europe
  LHR: { code: 'LHR', city: '伦敦', country: '英国', fullName: '伦敦希思罗机场' },
  LGW: { code: 'LGW', city: '伦敦', country: '英国', fullName: '伦敦盖特威克机场' },
  CDG: { code: 'CDG', city: '巴黎', country: '法国', fullName: '巴黎戴高乐机场' },
  ORY: { code: 'ORY', city: '巴黎', country: '法国', fullName: '巴黎奥利机场' },
  FCO: { code: 'FCO', city: '罗马', country: '意大利', fullName: '罗马菲乌米奇诺机场' },
  MXP: { code: 'MXP', city: '米兰', country: '意大利', fullName: '米兰马尔彭萨机场' },
  MAD: { code: 'MAD', city: '马德里', country: '西班牙', fullName: '马德里-巴拉哈斯机场' },
  AGP: { code: 'AGP', city: '马拉加', country: '西班牙', fullName: '马拉加-太阳海岸机场' },
  BCN: { code: 'BCN', city: '巴塞罗那', country: '西班牙', fullName: '巴塞罗那-埃尔普拉特机场' },
  AMS: { code: 'AMS', city: '阿姆斯特丹', country: '荷兰', fullName: '阿姆斯特丹史基浦机场' },
  FRA: { code: 'FRA', city: '法兰克福', country: '德国', fullName: '法兰克福国际机场' },
  BER: { code: 'BER', city: '柏林', country: '德国', fullName: '柏林勃兰登堡机场' },
  MUC: { code: 'MUC', city: '慕尼黑', country: '德国', fullName: '慕尼黑弗朗茨·约瑟夫·施特劳斯机场' },
  VIE: { code: 'VIE', city: '维也纳', country: '奥地利', fullName: '维也纳国际机场' },
  ZRH: { code: 'ZRH', city: '苏黎世', country: '瑞士', fullName: '苏黎世机场' },
  PRG: { code: 'PRG', city: '布拉格', country: '捷克', fullName: '布拉格瓦茨拉夫·哈维尔机场' },
  WAW: { code: 'WAW', city: '华沙', country: '波兰', fullName: '华沙肖邦机场' },
  IST: { code: 'IST', city: '伊斯坦布尔', country: '土耳其', fullName: '伊斯坦布尔阿塔图尔克机场' },
  
  // North America
  LAX: { code: 'LAX', city: '洛杉矶', country: '美国', fullName: '洛杉矶国际机场' },
  SFO: { code: 'SFO', city: '旧金山', country: '美国', fullName: '旧金山国际机场' },
  JFK: { code: 'JFK', city: '纽约', country: '美国', fullName: '纽约肯尼迪国际机场' },
  ORD: { code: 'ORD', city: '芝加哥', country: '美国', fullName: '芝加哥奥黑尔国际机场' },
  DFW: { code: 'DFW', city: '达拉斯', country: '美国', fullName: '达拉斯/沃斯堡国际机场' },
  YYZ: { code: 'YYZ', city: '多伦多', country: '加拿大', fullName: '多伦多皮尔逊国际机场' },
  YVR: { code: 'YVR', city: '温哥华', country: '加拿大', fullName: '温哥华国际机场' },
  
  // Australia
  SYD: { code: 'SYD', city: '悉尼', country: '澳大利亚', fullName: '悉尼金斯福德·史密斯机场' },
  MEL: { code: 'MEL', city: '墨尔本', country: '澳大利亚', fullName: '墨尔本国际机场' },
  PER: { code: 'PER', city: '珀斯', country: '澳大利亚', fullName: '珀斯国际机场' },
  
  // Japan
  HND: { code: 'HND', city: '东京', country: '日本', fullName: '东京羽田机场' },
  NRT: { code: 'NRT', city: '东京', country: '日本', fullName: '东京成田国际机场' },
  KIX: { code: 'KIX', city: '大阪', country: '日本', fullName: '关西国际机场' },
  FUK: { code: 'FUK', city: '福岡', country: '日本', fullName: '福岡空港' },
  
  // South Korea
  ICN: { code: 'ICN', city: '首尔', country: '韩国', fullName: '首尔仁川国际机场' },
  GMP: { code: 'GMP', city: '首尔', country: '韩国', fullName: '首尔金浦国际机场' },
};

// Common English/alias -> IATA code mapping for city names and common aliases.
// This helps when users input 'Hong Kong', 'Singapore', 'Tokyo' in English.
export const IATA_CITY_ALIASES: Record<string, string> = {
  'hong kong': 'HKG',
  'hongkong': 'HKG',
  'macau': 'MFM',
  'macau (mfm)': 'MFM',
  'macau mfm': 'MFM',
  'taipei': 'TPE',
  'tai pei': 'TPE',
  'taiwan': 'TPE',
  'singapore': 'SIN',
  'bangkok': 'BKK',
  'kuala lumpur': 'KUL',
  'jakarta': 'CGK',
  'manila': 'MNL',
  'hanoi': 'HAN',
  'ho chi minh': 'SGN',
  'delhi': 'DEL',
  'mumbai': 'BOM',
  'beijing': 'PEK',
  'shanghai': 'PVG',
  'shenzhen': 'SZX',
  'guangzhou': 'CAN',
  'tokyo': 'HND',
  'osaka': 'KIX',
  'fukuoka': 'FUK',
  '福岡': 'FUK',
  'seoul': 'ICN',
  'los angeles': 'LAX',
  'san francisco': 'SFO',
  'new york': 'JFK',
  'london': 'LHR',
};

/**
 * Get airport info by IATA code
 * @param code IATA code (e.g., 'PVG')
 * @returns AirportInfo or undefined if not found
 */
export const getAirportInfo = (code?: string): AirportInfo | undefined => {
  if (!code) return undefined;
  return IATA_AIRPORTS[code.toUpperCase()];
};

/**
 * Get airport city name
 * @param code IATA code
 * @returns City name or the code itself as fallback
 */
export const getAirportCity = (code?: string): string => {
  if (!code) return '--';
  const info = getAirportInfo(code);
  return info?.city || code;
};

/**
 * Get airport country name
 * @param code IATA code
 * @returns Country name or empty string as fallback
 */
export const getAirportCountry = (code?: string): string => {
  if (!code) return '';
  const info = getAirportInfo(code);
  return info?.country || '';
};

/**
 * Try to find an airport code by city name (best-effort).
 * Returns the first matching IATA code or undefined.
 */
export const findAirportCodeByCity = (city?: string): string | undefined => {
  if (!city) return undefined;
  let key = String(city).trim().toLowerCase();
  // Normalize spaces and punctuation for alias matching
  const normalized = key.replace(/[^a-z0-9]/g, ' ').replace(/\s+/g, ' ').trim();

  // 1) check alias table for common English names
  if (IATA_CITY_ALIASES[normalized]) return IATA_CITY_ALIASES[normalized];

  // 2) exact match on stored city names (usually localized names)
  for (const code of Object.keys(IATA_AIRPORTS)) {
    const info = IATA_AIRPORTS[code];
    if (!info) continue;
    if (info.city && info.city.toLowerCase() === key) return code;
    if (info.city && info.city.toLowerCase() === normalized) return code;
  }

  // 3) partial includes match on city or fullName (case-insensitive)
  for (const code of Object.keys(IATA_AIRPORTS)) {
    const info = IATA_AIRPORTS[code];
    if (!info) continue;
    if (info.city && info.city.toLowerCase().includes(key)) return code;
    if (info.city && info.city.toLowerCase().includes(normalized)) return code;
    if (info.fullName && info.fullName.toLowerCase().includes(key)) return code;
    if (info.fullName && info.fullName.toLowerCase().includes(normalized)) return code;
  }

  return undefined;
};

/**
 * Get airport info by city name (best-effort) returning AirportInfo or undefined
 */
export const getAirportByCity = (city?: string): AirportInfo | undefined => {
  const code = findAirportCodeByCity(city);
  return code ? IATA_AIRPORTS[code] : undefined;
};

/**
 * Minimal airline IATA mapping included here so both airports and airlines
 * live in the same constants module. This keeps iata-related helpers
 * centralized.
 */
export const IATA_AIRLINES: Record<string, { iata: string; name?: string }> = {
  'cathay pacific': { iata: 'CX', name: 'Cathay Pacific' },
  'cathay': { iata: 'CX', name: 'Cathay Pacific' },
  // Chinese name variants
  '國泰航空': { iata: 'CX', name: 'Cathay Pacific' },
  '國泰': { iata: 'CX', name: 'Cathay Pacific' },
  'hong kong airlines': { iata: 'HX', name: 'Hong Kong Airlines' },
  'hongkongair': { iata: 'HX', name: 'Hong Kong Airlines' },
  '香港航空': { iata: 'HX', name: 'Hong Kong Airlines' },
  'china airlines': { iata: 'CI', name: 'China Airlines' },
  '中華航空': { iata: 'CI', name: 'China Airlines' },
  'eva air': { iata: 'BR', name: 'EVA Air' },
  '長榮航空': { iata: 'BR', name: 'EVA Air' },
  '長榮': { iata: 'BR', name: 'EVA Air' },
  'japan airlines': { iata: 'JL', name: 'Japan Airlines' },
  'jal': { iata: 'JL', name: 'Japan Airlines' },
  '日本航空': { iata: 'JL', name: 'Japan Airlines' },
  'ana': { iata: 'NH', name: 'All Nippon Airways' },
  'all nippon airways': { iata: 'NH', name: 'All Nippon Airways' },
  '全日空': { iata: 'NH', name: 'All Nippon Airways' },
  'singapore airlines': { iata: 'SQ', name: 'Singapore Airlines' },
  'singaporeair': { iata: 'SQ', name: 'Singapore Airlines' },
  'british airways': { iata: 'BA', name: 'British Airways' },
  'ba': { iata: 'BA', name: 'British Airways' },
  'american airlines': { iata: 'AA', name: 'American Airlines' },
  'delta': { iata: 'DL', name: 'Delta Air Lines' },
  'delta air lines': { iata: 'DL', name: 'Delta Air Lines' },
  'united': { iata: 'UA', name: 'United Airlines' },
  'air china': { iata: 'CA', name: 'Air China' },
  'china eastern': { iata: 'MU', name: 'China Eastern' },
  'china southern': { iata: 'CZ', name: 'China Southern' },
  'qantas': { iata: 'QF', name: 'Qantas' },
};

/**
 * Resolve an airline IATA code from an operator string.
 * - If input looks like a 2-letter code, return uppercased input.
 * - Else, normalize and search the mapping for a best-effort match.
 */
export const getAirlineIata = (operator?: string): string | undefined => {
  if (!operator) return undefined;
  const s = String(operator).trim();
  if (s.length === 2 && /^[A-Za-z]{2}$/.test(s)) return s.toUpperCase();
  const key = s.toLowerCase();
  if (IATA_AIRLINES[key]) return IATA_AIRLINES[key].iata;
  for (const k of Object.keys(IATA_AIRLINES)) {
    if (key.includes(k)) return IATA_AIRLINES[k].iata;
  }
  return undefined;
};

export const getAirlineDisplay = (operator?: string): string | undefined => {
  if (!operator) return undefined;
  const iata = getAirlineIata(operator);
  if (iata) return iata;
  return operator;
};
